import React from 'react';
import { Col, Row, Label, Button } from 'reactstrap';
import Card from '../../../comum/components/Card';
import { observer } from 'mobx-react';
import SelectFiltro from '../../../comum/components/SelectFiltro';
import { DateRangePicker, ICON_AFTER_POSITION } from 'react-dates';
import { Filtro, IconeCarregar } from '../../../comum/components/Icones';

@observer
export class FiltrosEstoque extends React.Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;

        this.state = {
            focusedInputEntrada: null,
            focusedInputDesova: null,
            focusedInputBl: null
        }
    }

    render() {
        return(
            <Card className="filtros area-form pb-0">
                <Row style={{paddingBottom: 0}}>
                    {
                        this.controller.carregandoClientes
                        ?<Col xs={12} sm={12} md={6} lg={4} xl={4}>
                            <IconeCarregar tamanho="2x" />
                        </Col>
                        :<SelectFiltro xs={12} sm={12} md={6} lg={4} xl={4}
                            titulo="Clientes"
                            value={this.controller.clienteSelecionado}
                            onChange={this.controller.selecionaCliente}
                            options={this.controller.clientes}
                        />
                    }
                    <SelectFiltro xs={12} sm={12} md={6} lg={2} xl={2}
                            titulo="Status Bl"
                            value={this.controller.statusBlSelecionado}
                            onChange={this.controller.selecionaStatusBl}
                            options={this.controller.statusBl}
                        />
                    <SelectFiltro xs={12} sm={12} md={6} lg={2} xl={2}
                            titulo="Modalidade"
                            value={this.controller.modalidadeSelecionado}
                            onChange={this.controller.selecionaModalidade}
                            options={this.controller.modalidades}
                        />
                    <Col xs={12} sm={12} md={6} lg={2} xl={2} className="mb-4">
                        <div className="w-100 d-flex flex-column justifu-content-start">
                            <Label className="mx-0">
                                Período entrada
                            </Label>
                            <DateRangePicker
                                startDate={this.controller.dataEntradaInicial}
                                startDateId="dataInicialEntrada"
                                endDate={this.controller.dataEntradaFinal}
                                endDateId="dataFinalEntrada"
                                startDatePlaceholderText="Data inicial"
                                endDatePlaceholderText="Data final"
                                onDatesChange={({startDate, endDate}) => this.controller.mudarDatasEntrada({startDate, endDate})}
                                focusedInput={this.state.focusedInputEntrada}
                                onFocusChange={focusedInputEntrada => this.setState({ focusedInputEntrada })}
                                hideKeyboardShortcutsPanel={true}
                                isOutsideRange={() => false}
                                numberOfMonths={1}
                                openDirection={
                                    this.props.openDirection ? this.props.openDirection : "down"
                                }
                                displayFormat={"DD MMM, YYYY"}
                                customArrowIcon="-"
                                showClearDates={true}
                                inputIconPosition={ICON_AFTER_POSITION}
                            />
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={2} xl={2} className="mb-4">
                        <div className="w-100 d-flex flex-column justifu-content-start">
                            <Label className="mx-0">
                                Período desova
                            </Label>
                            <DateRangePicker
                                startDate={this.controller.dataDesovaInicial}
                                startDateId="dataInicialDesova"
                                endDate={this.controller.dataDesovaFinal}
                                endDateId="dataFinalDesova"
                                startDatePlaceholderText="Data inicial"
                                endDatePlaceholderText="Data final"
                                onDatesChange={({startDate, endDate}) => this.controller.mudarDatasDesova({startDate, endDate})}
                                focusedInput={this.state.focusedInputDesova}
                                onFocusChange={focusedInputDesova => this.setState({ focusedInputDesova })}
                                hideKeyboardShortcutsPanel={true}
                                isOutsideRange={() => false}
                                numberOfMonths={1}
                                openDirection={
                                    this.props.openDirection ? this.props.openDirection : "down"
                                }
                                displayFormat={"DD MMM, YYYY"}
                                customArrowIcon="-"
                                showClearDates={true}
                                inputIconPosition={ICON_AFTER_POSITION}
                            />
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={2} xl={2} className="mb-4">
                        <div className="w-100 d-flex flex-column justifu-content-start">
                            <Label className="mx-0">
                                Período Finalização BL
                            </Label>
                            <DateRangePicker
                                startDate={this.controller.dtBlFinalizInicial}
                                startDateId="dataIniciaBL"
                                endDate={this.controller.dtBlFinalizFinal}
                                endDateId="dataFinalBl"
                                startDatePlaceholderText="Data inicial"
                                endDatePlaceholderText="Data final"
                                onDatesChange={({startDate, endDate}) => this.controller.mudarDatasBlFinaliz({startDate, endDate})}
                                focusedInput={this.state.focusedInputBl}
                                onFocusChange={focusedInputBl => this.setState({ focusedInputBl })}
                                hideKeyboardShortcutsPanel={true}
                                isOutsideRange={() => false}
                                numberOfMonths={1}
                                openDirection={
                                    this.props.openDirection ? this.props.openDirection : "down"
                                }
                                displayFormat={"DD MMM, YYYY"}
                                customArrowIcon="-"
                                showClearDates={true}
                                inputIconPosition={ICON_AFTER_POSITION}
                            />
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={2} lg={2} xl={2}>
                        <Button className="btn-filtros" onClick={this.controller.abrirFiltros} outline>
                            <Filtro color="#93A0AD"
                                className="mr-2"
                                width="15"
                                height="15" />
                            Customizar
                        </Button>
                        <Button onClick={this.controller.listarEstoque} className="btn-com-bordas-primary btn-filtrar">Filtrar</Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <b>
                            Relatório de controle de cargas na modalidade de importação e cabotagem (descarga) para simples conferência, em caso de divergência sinalize a equipe de Atendimento
                        </b>
                    </Col>
                </Row>
            </Card>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/consultas/estoque/components/FiltrosEstoque.js